import React from "react";
import CTAButton from "../../Buttons/CTAButton/CTAButton";
import MessageImage from '../../../assets/images/dean-image.jpg'

const MessageContent = () => {
  return (
    <div className="px-4 sm:px-8 md:px-12 lg:px-numbers-48">
      <div className="self-stretch p-2 sm:p-4 bg-Color-White shadow-[0px_0px_80px_0px_rgba(0,0,0,0.10)] inline-flex flex-col lg:flex-row justify-start items-center gap-2 overflow-hidden">
        <div className=" flex-1 flex lg:hidden justify-start items-center gap-2 w-full lg:w-auto">
          <img
            className="flex-1 w-full "
            src={MessageImage}
          />
        </div>
        <div className=" flex-1 px-4 sm:px-6 md:px-8 py-4 border-l-2 border-Color-Brand inline-flex flex-col justify-end items-start gap-6 sm:gap-8 md:gap-10">
          <div className="self-stretch justify-start">
            <span className="text-Color-Black text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-normal font-['Montserrat']">
              Message from the
            </span>
            <span className="text-Color-Black text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-normal font-['Montserrat']">
              {" "}
            </span>
            <span className="text-Color-Brand text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold font-['Montserrat'] underline">
              Dean
            </span>
          </div>
          <div className="self-stretch justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] tracking-tight">
            "Welcome to the Faculty of Engineering, University of Ruhuna. We are
            celebrating the silver jubilee this year, making an outstanding 25
            years of continuous service to the country in the state sector
            higher education, becoming one of the top-ranking engineering
            faculties in the country."
          </div>
        <CTAButton text="READ MORE" url="https://www.eng.ruh.ac.lk/about/" target="_blank"/>
        </div>
        <div className="hidden flex-1 lg:flex justify-start items-center gap-2 w-full lg:w-auto">
          <img
            className="flex-1 w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[489px] object-cover"
            src={MessageImage}
          />
        </div>
      </div>
    </div>
  );
};

export default MessageContent;